<template>
  <div>
    <tTabs
      :selectType.sync="selectType"
      :typeData="typeData"
    />
    <!--项目申请模版-->
    <applyTemplate v-if="selectType === '1'" />
    <!--项目申请及阶段查询-->
    <applyQuery v-if="selectType === '2'" />
    <!--项目备案清单-->
    <bakList v-if="selectType === '3'" />
    <!--项目实施监督-->
    <actionWatch v-if="selectType === '4'" />
  </div>
</template>

<script>
import applyTemplate from './components/applyTemplate'
import applyQuery from './components/applyQuery'
import bakList from './components/bakList'
import actionWatch from './components/actionWatch'
export default {
  name: 'index',
  components: {
    applyTemplate,
    applyQuery,
    bakList,
    actionWatch
  },
  data () {
    return {
      selectType: '1',
      typeData: [
        { id: '1', name: '项目申请模版' },
        { id: '2', name: '项目申请及阶段查询' },
        { id: '3', name: '项目备案清单' },
        { id: '4', name: '项目实施监督' }
      ]
    }
  },
  created () {
    const { query } = this.$route
    if (query.id) {
      this.selectType = query.id
    }
  },
  methods: {
    changeType (item) {
      const { id } = item
      this.selectType = id
    }
  }
}
</script>

<style lang="less" scoped>
.group_6 {
  width: 1054px;
  .group_7 {
    margin-right: 15px;
    line-height: 15px;
    .font_4 {
      font-size: 15px;
      font-family: PingFang;
      line-height: 15px;
      font-weight: 700;
    }
    .text_9 {
      color: #cccccc;
      font-size: 14px;
    }
    .text_10 {
      color: #666666;
      font-size: 14px;
      line-height: 14px;
    }
  }
  .group_8 {
    margin-top: 18px;

    .item{
      font-size: 14px;
      color: #999;
      min-width: 122px;
      text-align: center;
      line-height: 40px;
      position: relative;
      top: 3px;
      cursor: pointer;
      padding: 0px 30px;

      &.active{
        color: #0067d1;
        border-bottom: 3px solid #0067d1;
      }
    }
    .font_5 {
      font-size: 15px;
      font-family: Alibaba;
    }
    .text_12 {
      color: #0067d1;
      font-size: 14px;
      line-height: 13px;
    }
    .text_13 {
      color: #999999;
      font-size: 14px;
      line-height: 14px;
    }
  }
  .divider {
    background-color: #0067d14d;
    .section_8 {
      width: 122px;
      height: 3px;
    }
  }
}
</style>
